var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguageSelectedIcon = function SvgLanguageSelectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#423DCF",
    strokeWidth: 2,
    d: "M26.834 14c0 7.088-5.746 12.833-12.834 12.833S1.167 21.088 1.167 14 6.913 1.167 14 1.167c7.088 0 12.834 5.745 12.834 12.833Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 7,
    y: 7,
    fill: "#423DCF",
    rx: 7
  })));
};
export default SvgLanguageSelectedIcon;